import { Comment, Avatar, Tooltip, Image, Skeleton, Divider } from 'antd';
import { CloudDownloadOutlined, CalendarOutlined } from '@ant-design/icons';
import React, { Dispatch, useState, memo, useEffect } from 'react';
import { Props } from './types';
import { ContentText, Name, Date, ContainerAnexo, Agrupamento, Attachments } from './styles';
import { ApplicationState } from '../../../../../../store';
import { Action } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { loadAttachmentsRequest } from '../../../../../../store/ducks/downloadAttachments/actions';
import moment from 'moment';
import { colorIconConversation } from '../../../../Utils';
import ContainerScroll from '../../../../../../components/ContainerScroll';
import { Messages } from '../../../../../../store/ducks/sendMenssages/types';
import mask from 'utils/mask';

const BoxMessage: React.FC<Props> = ({ protocolo }) => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const [visible, setVisible] = useState(false);
  const [mensagens, setMensagens] = useState<Messages[]>([]);

  const loading = useSelector((state: ApplicationState) => state.AtendimentoMensagens.loading);
  const loadingOcorrencia = useSelector((state: ApplicationState) => state.Ocorrencia.loading);
  const usuarios = useSelector((state: ApplicationState) => state.Ocorrencia.data['usuarios']);
  const conversa: Messages[] = useSelector(
    (state: ApplicationState) => state.Ocorrencia.data['mensagens']
  );

  const ocorrencia = useSelector((state: ApplicationState) => state.Ocorrencia.data['ocorrencia']);
  const novasMessage = useSelector((state: ApplicationState) => state.AtendimentoMensagens.data);

  useEffect(() => {
    if (novasMessage?.mensagens.length > 0) {
      setMensagens(novasMessage.mensagens);
    } else {
      setMensagens(conversa);
    }
  }, [conversa, novasMessage]);

  const showTimer = (tempo: string) => {
    const dataAtual = moment().format('DD/MM/YYYY HH:mm');
    const dataOcorrencia = moment(tempo).format('DD/MM/YYYY HH:mm');
    const data1 = moment(dataAtual, 'DD/MM/YYYY HH:mm');
    const data2 = moment(dataOcorrencia, 'DD/MM/YYYY HH:mm');

    const diff = data1.diff(data2, 'minutes');
    if (diff < 60) {
      return `${diff} minutos atrás`;
    }

    const diffHours = data1.diff(data2, 'hours');
    if (diffHours < 24) {
      return `${diffHours} horas atrás`;
    }

    const diffDays = data1.diff(data2, 'days');
    if (diffDays < 30) {
      return `${diffDays} dias atrás`;
    }

    const diffMonth = data1.diff(data2, 'months');
    if (diffMonth < 12) {
      return `${diffMonth} meses atrás`;
    }

    const diffYear = data1.diff(data2, 'years');
    if (diffYear < 12) {
      return `${diffYear} anos atrás`;
    }
    return diff;
  };

  const getAvatar = (cod: number) => {
    const usuarioOcorrencia = usuarios.find((item: any) => item.codUsu === cod);
    const usuarioNovaMessagem = novasMessage?.usuarios?.find((item: any) => item.codUsu === cod);

    const avatar = usuarioOcorrencia?.avatar || usuarioNovaMessagem?.avatar;
    return avatar;
  };

  const getName = (cod: number) => {
    const usuario = usuarios.find((item: any) => item.codUsu === cod);
    return mask('camelCase', usuario?.nome);
  };

  const groupForDate = (array: Messages[], property: string) => {
    return array?.reduce((acc: any, obj: any) => {
      if (!obj.hasOwnProperty(property)) return acc;
      const key = moment(obj[property]).format('ll');
      if (!acc[key]) acc[key] = [];
      acc[key].push(obj);
      return acc;
    }, {});
  };
  let colorIcon = colorIconConversation(ocorrencia?.urgencia);

  const groupMessage = groupForDate(mensagens, 'dhInclusao');

  const datas =
    groupMessage &&
    Object.keys(groupMessage)?.map((key) => {
      return {
        date: key,
        menssages: groupMessage[key],
      };
    });

  return (
    <>
      {!loading && !loadingOcorrencia && (
        <ContainerScroll maxHeight="500px" minHeight="400px" total={mensagens?.length}>
          {datas?.map((mensagem: any) => (
            <li key={mensagem.date}>
              <>
                <Divider className="themeSLA">
                  <Agrupamento>
                    <CalendarOutlined
                      style={{
                        color: colorIcon,
                        fontSize: '12px',
                        marginRight: '4px',
                      }}
                    />
                    {mensagem?.date}
                  </Agrupamento>
                </Divider>

                {mensagem?.menssages?.map((mensagem: any) => (
                  <div key={mensagem?.seq}>
                    <Comment
                      actions={[]}
                      author={<Name className="themeSLA">{getName(mensagem?.codUsu)}</Name>}
                      avatar={
                        <span onClick={() => setVisible(true)}>
                          {getAvatar(mensagem?.codUsu) ? (
                            <Image.PreviewGroup>
                              <Image
                                src={'data:image/png;base64,' + getAvatar(mensagem?.codUsu)}
                                style={{ display: 'block' }}
                                preview={{
                                  visible,
                                  src: 'data:image/png;base64,' + getAvatar(mensagem?.codUsu),
                                  onVisibleChange: (value) => {
                                    setVisible(value);
                                  },
                                }}
                              />
                            </Image.PreviewGroup>
                          ) : (
                            <Avatar alt="imagem do usuário" />
                          )}
                        </span>
                      }
                      datetime={
                        <Tooltip title={moment(mensagem.dhInclusao).format('DD/MM/YYYY HH:mm')}>
                          <Date className="themeSLA">{showTimer(mensagem.dhInclusao)}</Date>
                        </Tooltip>
                      }
                      content={
                        <ContentText data-cy="message" className="themeSLA">
                          {mensagem.texto}
                        </ContentText>
                      }
                    />

                    <ContainerAnexo>
                      {mensagem.anexos > 0 && (
                        <Attachments
                          data-cy="download-zip"
                          onClick={() => {
                            dispatch(loadAttachmentsRequest(protocolo, mensagem?.seq));
                          }}
                        >
                          <div>
                            <div>Baixar anexo(s)</div>
                            <div>Anexo.zip</div>
                          </div>{' '}
                          <CloudDownloadOutlined className="icon" />
                        </Attachments>
                      )}
                    </ContainerAnexo>
                  </div>
                ))}
              </>
            </li>
          ))}
        </ContainerScroll>
      )}
      {(loading || loadingOcorrencia) && (
        <div style={{ minHeight: '480px' }}>
          <div style={{ marginTop: '20px' }}>
            <Skeleton.Avatar active={true} size="default" shape="circle" />
            <Skeleton active />
          </div>
          <div style={{ marginTop: '20px' }}>
            <Skeleton.Avatar active={true} size="default" shape="circle" />
            <Skeleton active />
          </div>
        </div>
      )}
    </>
  );
};
export default memo(BoxMessage);
